export default __webpack_public_path__ + "4996751df0d40bdebab559061d9f608c.svg";